import { render } from "./AddNewBorn.vue?vue&type=template&id=678b27f6&scoped=true"
import script from "./AddNewBorn.vue?vue&type=script&lang=js"
export * from "./AddNewBorn.vue?vue&type=script&lang=js"

import "./AddNewBorn.vue?vue&type=style&index=0&id=678b27f6&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678b27f6"]])

export default __exports__